import React from 'react';
import styles from './GeneralDetails.module.scss';
import { useFormContext } from 'react-hook-form';
import { formatDate } from 'helpers/AppHelpers';

export default function GeneralDetails() {
  const { getValues } = useFormContext();

  const data = [
    {
      id: 1,
      label: 'Report name',
      value: getValues('generalReportTemplate')?.name || ''
    },
    {
      id: 2,
      label: 'Entity',
      value:
        getValues('asset')?.drCode ||
        getValues('location')?.siteCode ||
        getValues('looseItem')?.name ||
        ''
    },
    {
      id: 3,
      label: 'Date',
      value: getValues('createdAtUtc')
        ? formatDate(getValues('createdAtUtc'))
        : formatDate(new Date())
    }
  ];

  return (
    <div className={styles.general}>
      {data.map((el) =>
        el?.value ? (
          <section key={el.id} className={styles.general_details}>
            <label>{el.label}</label>
            <b>{el.value}</b>
          </section>
        ) : null
      )}
    </div>
  );
}
